import React from 'react'
import { FieldProps } from '../../types'
import { Icon } from '../../../../../base/icon'
import theme from '../../../../../../styles/figma-tokens.json'

const CustomCheckbox: React.FC<FieldProps> = ({ options, value, onChange }) => {
  return (
    <li className='flex w-full flex-col'>
      {options?.map((option, index) => (
        <ul key={option.value.toString()} className='flex w-full'>
          <button
            onClick={() => onChange(option.value)}
            id={`${option.label.toLowerCase()}-button`}
            className={`ite ms-center flex w-full justify-between py-4 ${options.length - 1 !== index && 'border-b-[1px] border-neutral-80'}`}
          >
            <div className='flex flex-col items-start'>
              <span className='text-xs font-regular text-text-primary'>{option.label}</span>
              {option.description && (
                <span className='text-2xs font-regular text-text-secondary'>
                  {option.description}
                </span>
              )}
            </div>

            <div
              className={`flex h-6 w-6 items-center justify-center rounded-xs border-[1px] border-background-brand-primary ${value === option.value && 'bg-background-brand-primary'}`}
            >
              <Icon size='18' name='check' color={theme.global.colorReference.neutral[100].value} />
            </div>
          </button>
        </ul>
      ))}
    </li>
  )
}

export default CustomCheckbox
